<template>
  <section class="summary-choices">
    <ul class="summary-choices__rows">
      <li
        v-for="(row, i) in rows"
        :key="`row-${i}-${row.sectionLabel}`"
        class="summary-choices__row"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.82125 3.72359C9.85132 3.51792 10.1486 3.51792 10.1787 3.72359C10.6392 6.881 13.1189 9.36077 16.2763 9.82125C16.482 9.85132 16.482 10.1486 16.2763 10.1787C13.1189 10.6392 10.6392 13.1189 10.1787 16.2763C10.1486 16.482 9.85132 16.482 9.82125 16.2763C9.36077 13.1189 6.881 10.6392 3.72359 10.1787C3.51792 10.1486 3.51792 9.85132 3.72359 9.82125C6.881 9.36077 9.36077 6.881 9.82125 3.72359Z"
            fill="#3876F0"
            fill-opacity="0.5"
          />
        </svg>
        <div class="summary-choices__row-body">
          <p class="summary-choices__row-title">
            <span
              >{{ row.sectionLabel }}: &ldquo;{{
                row.quotedChoice
              }}&rdquo;</span
            >
            <span class="summary-choices__quote"> </span>
          </p>
          <p class="summary-choices__row-desc">
            {{ row.benefitLine }}
          </p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import type { SummaryRow } from '@/models/onboarding.types'

defineProps<{
  rows: SummaryRow[]
}>()
</script>

<style lang="scss" scoped>
.summary-choices {
  background: $c-white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 20px 16px;

  &__rows {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__row {
    display: flex;
    gap: 12px;
    padding-block: 16px;

    &:not(:last-child) {
      border-bottom: 1px solid $c-border-7;
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }
  }

  &__star {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 14px;
    color: $c-blue-3;
  }

  &__row-body {
    flex: 1;
    min-width: 0;
  }

  &__row-title {
    margin: 0 0 6px;
    font-size: 16px;
    font-style: italic;
    line-height: 130%;
  }

  &__quote {
    font-style: italic;
  }

  &__row-desc {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: $c-black-15;
  }
}
</style>
